"use strict";

angular.module("vendor")
.component("productDeposits", {
    templateUrl: require("./product-deposits.component.html"),
    controller: ProductDepositsController,
    controllerAs: "productDepositsCtrl",
    bindings: {
        product: "=",
        form: "="
    }
});

function ProductDepositsController(
    $scope, Language
) {
    var _this = this;

    Language.initializeScope($scope, "language", "locale");

    this.removeProductDeposit = function(index) {
        _this.product.product_deposits.splice(index, 1);
        _this.form.$setDirty();
    };

    this.addProductDeposit = function() {
        if (!_this.product.product_deposits) {
            _this.product.product_deposits = [];
        }
        _this.product.product_deposits.push({
            product: null,
            deposits_per_package: 1,
        });
        _this.form.$setDirty();
    };
}



//////////////////
// WEBPACK FOOTER
// ./vendor/sections/product/product-deposits/product-deposits.component.js
// module id = 917
// module chunks = 0